import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { StatsTerminalRes } from '@/views/dashboard/home/home.service'

/** 部署状态 */
export interface DeployStatus {
  deployed_count: number
  online_count: number
  offline_count: number
}

@Injectable()
export class DeployControlService {
  constructor (
    private http: Http,
  ) {}
  /** 获取部署状态 */
  getDeployStatus () {
    return this.http.post<StatsTerminalRes>('/homepage/stats/terminal', {}).then(res => {
      return {
        deployed_count: res.deploy_count || 0,
        online_count: res.online_count || 0,
        offline_count: res.offline_count || 0
      }
    })
  }
}
